import { useQuery } from '@apollo/client/react';
import { Alert, Grid } from '@mui/material';
import { Image } from '@realadvisor/image';
import { StoreIcon } from 'lucide-react';
import { useParams } from 'react-router-dom';

import { CoverPhotoPlaceholder } from '@modules/_shared/components/CoverPhoto';
import { useAppData } from '@modules/_shared/providers/AppDataProvider';
import { OVERVIEW_GET_TEAM } from '@modules/teams/teamQueries';
import { TeamScoreCards } from '@modules/teams/TeamScoreCards';
import { TeamUsers } from '@modules/teams/TeamUsers';
import { customPalette, rawPalette } from '@shared/theme/StyleProvider';
import { useTheme } from '@shared/theme/theme';

export const TeamOverview = () => {
  const { colors } = useTheme();
  const { teamId } = useParams() as { teamId: string };
  const { me } = useAppData();

  const { loading, data, error } = useQuery(OVERVIEW_GET_TEAM, {
    variables: { id: teamId, includeSubscriptions: me?.is_admin || false },
  });

  return (
    <>
      {error && (
        <Alert severity="error" sx={{ m: 2 }}>
          <pre>{JSON.stringify(error, null, 2)}</pre>
        </Alert>
      )}
      <div
        style={{
          width: '100%',
          height: 260,
          position: 'relative',
          flexShrink: 0,
          borderBottom: `1px solid ${colors.divider}`,
        }}
      >
        {data?.teams_by_pk?.cover_photo?.url ? (
          <Image
            src={data?.teams_by_pk?.cover_photo?.url}
            options={{ w: 1000 }}
          />
        ) : (
          <CoverPhotoPlaceholder />
        )}
        <div
          style={{
            position: 'absolute',
            left: 20,
            bottom: 20,
            height: 150,
            width: 150,
            borderRadius: 12,
            backgroundColor: data?.teams_by_pk?.logo?.url
              ? rawPalette.white
              : customPalette.white,
            padding: 12,
            display: 'flex',
          }}
        >
          {data?.teams_by_pk?.logo?.url ? (
            <Image
              src={data?.teams_by_pk?.logo?.url ?? ''}
              options={{ w: 250 }}
              objectFit="contain"
            />
          ) : (
            <StoreIcon
              style={{ margin: 'auto' }}
              size={100}
              color={customPalette.gray300}
            />
          )}
        </div>
      </div>
      <Grid
        container
        spacing={2}
        sx={{
          padding: 2,
          zIndex: 2,
        }}
      >
        <Grid size={12}>
          {me?.is_admin && (
            <TeamScoreCards team={data?.teams_by_pk} loading={loading} />
          )}
          <TeamUsers team={data?.teams_by_pk} loading={loading} />
        </Grid>
      </Grid>
    </>
  );
};
